document.body.style.overflowY = "hidden"
import {
	ViewerApp,
	AssetManagerPlugin,
	timeout,
	SSRPlugin,
	mobileAndTabletCheck,
	GBufferPlugin,
	ProgressivePlugin,
	TonemapPlugin,
	SSAOPlugin,
	GroundPlugin,
	FrameFadePlugin,
	PCFShadowMap,
	Mesh,
	BloomPlugin, TemporalAAPlugin, RandomizedDirectionalLightPlugin, AssetImporter, Color, MeshStandardMaterial2,
} from "webgi"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import "./styles.scss"

gsap.registerPlugin(ScrollTrigger)

async function setupViewer() {

	const viewer = new ViewerApp({
		canvas: document.getElementById('webgi-canvas') as HTMLCanvasElement,
		useRgbm: true,
		useGBufferDepth: false,
		isAntialiased: false
	})

	const isMobile = mobileAndTabletCheck()

	viewer.renderer.displayCanvasScaling = Math.min(window.devicePixelRatio, 1.5)
	viewer.renderer.rendererObject.shadowMap.type = PCFShadowMap

	const manager = await viewer.addPlugin(AssetManagerPlugin)
	const camera = viewer.scene.activeCamera
	const position = camera.position
	const target = camera.target
	// const clock = viewer.scene

	// Interface Elements
	const exploreView = document.querySelector('.cam-view-4') as HTMLElement
	const canvasView = document.getElementById('webgi-canvas') as HTMLElement
	const canvasContainer = document.getElementById('webgi-canvas-container') as HTMLElement
	const exitContainer = document.querySelector('.exit--container') as HTMLElement
	const loaderElement = document.querySelector('.loader') as HTMLElement
	const buttonCustomize = document.querySelector('.button--customize') as HTMLElement
	const customizeContent = document.querySelector('.customize--content') as HTMLElement


	// Add WEBGi plugins
	await viewer.addPlugin(GBufferPlugin)
	await viewer.addPlugin(new ProgressivePlugin(32))
	await viewer.addPlugin(new TonemapPlugin(true, true))
	const ssr = await viewer.addPlugin(SSRPlugin)
	const ssao = await viewer.addPlugin(SSAOPlugin)
	await viewer.addPlugin(FrameFadePlugin)
	await viewer.addPlugin(GroundPlugin)
	const bloom = await viewer.addPlugin(BloomPlugin)
	await viewer.addPlugin(TemporalAAPlugin)
	await viewer.addPlugin(RandomizedDirectionalLightPlugin, false)

	ssr!.passes.ssr.passObject.lowQualityFrames = 0
	bloom.pass!.passObject.bloomIterations = 2
	ssao.passes.ssao.passObject.material.defines.NUM_SAMPLES = 4

	const importer = manager.importer as AssetImporter

	importer.addEventListener("onStart", (ev) => {
		target.set(8.16, -0.13, 0.51)
		position.set(3.6, -0.04, -3.93)
		onUpdate()
	})

	importer.addEventListener("onProgress", (ev) => {
		const progressRatio = (ev.loaded / ev.total)
		document.querySelector('.progress')?.setAttribute('style', `transform: scaleX(${progressRatio})`)
	})

	importer.addEventListener("onLoad", (ev) => {
		introAnimation()
	})

	viewer.renderer.refreshPipeline()

	await manager.addFromPath("./assets/apple_watch_xx3.glb")

	const clock = viewer.scene.findObjectsByName('Scene')[0]
	const glass = viewer.scene.findObjectsByName('glass')[0]
	const strapMaterial = manager.materials!.findMaterialsByName('rubber')[0] as MeshStandardMaterial2
	const scrubberMaterial = manager.materials!.findMaterialsByName('sSZvqgMuWCuMkAr')[0] as MeshStandardMaterial2
	const scrubberMaterialCenter = manager.materials!.findMaterialsByName('upTfEpgNFxflqtf')[0] as MeshStandardMaterial2
	const caseMaterial = manager.materials!.findMaterialsByName('JUrNntQLbxHnFtO')[0] as MeshStandardMaterial2
	const watchFaceMaterial = manager.materials!.findMaterialsByName('YRNmAgRITIuwDMU')[0] as MeshStandardMaterial2
	const hourHand = viewer.scene.findObjectsByName('hours')[0] as any as Mesh
	const minuteHand = viewer.scene.findObjectsByName('minutes')[0] as any as Mesh
	const secondHand = viewer.scene.findObjectsByName('seconds')[0] as any as Mesh

	if (camera.controls) camera.controls.enabled = false

	if (isMobile) {
		ssr.passes.ssr.passObject.stepCount /= 2
		bloom.enabled = false
		camera.setCameraOptions({ fov: 65 })
	}

	window.scrollTo(0, 1)

	await timeout(90)
	glass.position.z = 1.255
	watchFaceMaterial.emissiveIntensity = 1.4

	function introAnimation() {
		const introTL = gsap.timeline()
		introTL
			.to('.loader', { x: '150%', duration: 0.8, ease: "power4.inOut", delay: 1 })
			// .to(viewer.scene.rotation, { x: -0.35, y: -0.20, z: 0.30, duration: 1 })
			.fromTo(position, { x: isMobile ? 2 : 3.91, y: -0.05, z: 2.44 }, { x: isMobile ? -1.8 : -2.75, y: isMobile ? -1 : -2.53, z: 5.63, duration: 4, onUpdate }, '-=1.0')
			.fromTo(target, { x: 1.9, y: -0.2, z: -2.24 }, { x: isMobile ? 0.25 : -0.2, y: isMobile ? -1 : 0.20, z: -0.5, duration: 4 }, '-=4')
			
			.fromTo('.header--container', { opacity: 0, y: '-100%' }, { opacity: 1, y: '0%', ease: "power1.inOut", duration: 0.8 }, '-=1')
			.fromTo('.intro--content', { opacity: 0, x:'150%' }, { x: '0%',opacity: 1, ease: "power4.inOut", duration: 1.8, onComplete: setupScrollAnimation }, '-=1')
	}

	function setupScrollAnimation() {
        document.body.style.overflowY = "scroll"

		document.body.removeChild(loaderElement)

		const tl = gsap.timeline({ default: { ease: 'none' } })

		// DETAIL SECTION
		tl
			// SOLAR SECTION
			//  .to(viewer.scene.rotation, { x: 0, y: 0, z: 0, duration: 1,
			//  	scrollTrigger: { trigger: ".cam-view-2", start: "top bottom", end: "top top", scrub: true, immediateRender: false }
			//   })
			 .to(clock.rotation, { x: -Math.PI/2, duration: 1,
			 	scrollTrigger: { trigger: ".cam-view-2", start: "top bottom", end: "top top", scrub: true, immediateRender: false }
			  })
			.to(position, {
				x: isMobile ? 2.25 : -3.2, y: 1.9, z: 0,
				scrollTrigger: { trigger: ".cam-view-2", start: "top bottom", end: "top top", scrub: true, immediateRender: false }, onUpdate
			})
			.to(target, {
				x: isMobile ? -0.99 : 0.1, y: isMobile ? 0.8 : 0.9, z: 0,
				scrollTrigger: { trigger: ".cam-view-2", start: "top bottom", end: "top top", scrub: true, immediateRender: false }
			})
			.to('.intro--content', {opacity: 0, x: '50%', ease: "power4.inOut",
				scrollTrigger: { trigger: ".cam-view-2", start: "top bottom", end: "top 70%", scrub: 1, immediateRender: false,
				pin: '.intro--content'
			}})

			// GLASS MOVEMENT SECTION
			.to(glass.position, {
				z: 1.5,
				scrollTrigger: {
					trigger: ".cam-view-3-5", start: "top bottom", end: "top top", scrub: true, immediateRender: false, onUpdate:
					() =>{
						viewer.setDirty()
					}, pin: '.solar--content'
				}
			})
			.to('.battery--icon', {
				scale: '1.5',
				scrollTrigger: {
					trigger: ".cam-view-3-5", start: "top bottom", end: "top top", scrub: true, immediateRender: false
				}
			})
			.fromTo('#clipping', {y: '-150%'}, {
				y: '150%',
				scrollTrigger: {
					trigger: ".cam-view-3-5", start: "top bottom", end: "top top", scrub: true, immediateRender: false
				}
			})
			.fromTo('#clipping2', {x: '-150%'}, {
				x: '0%',
				scrollTrigger: {
					trigger: ".cam-view-3-5", start: "top bottom", end: "top top", scrub: true, immediateRender: false
				}
			})
			.to('.solar--content', {opacity: 0, ease: "power4.inOut",
			scrollTrigger: { trigger: ".cam-view-3-5", start: "top bottom", end: "top 10%", scrub: 1, immediateRender: false}
			})

			// ECO SECTION

			.to(glass.position, {
				z: 1.255,
				scrollTrigger: {
					trigger: ".cam-view-3", start: "top bottom", end: "top top", scrub: true, immediateRender: false, onUpdate:
					() =>{
						viewer.setDirty()
					}
				}
			})
			.to(position, {
				x: isMobile ? 2.35 : 6, y: isMobile ? 0.1 : -1.44, z: isMobile ? -0.1 : 6,
				scrollTrigger: {
					trigger: ".cam-view-3", start: "top bottom", end: "top top", scrub: true, immediateRender: false,
				}, onUpdate
			})
			.to(target, {
				x: 0.5, y: 0.06, z: 0.1,
				scrollTrigger: { trigger: ".cam-view-3", start: "top bottom", end: "top top", scrub: true, immediateRender: false }, onUpdate
			})
			.to(clock.rotation, {
				x: -Math.PI/6, y: 0, z: Math.PI /5,
				scrollTrigger: { trigger: ".cam-view-3", start: "top bottom", end: "top top", scrub: true, immediateRender: false }
			})
			
			.fromTo('.eco--content h1', { opacity: 0, x: '70%' }, {
				opacity: 1, x: '20%', duration: 0.8, ease: "power4.inOut",
				scrollTrigger: {
					trigger: ".cam-view-3", start: "top bottom", end: "top top", scrub: 1, immediateRender: false
				}
			})
			.fromTo('.eco-text', { opacity: 0, x: '100%' }, {
				opacity: 1, x: '0%', duration: 0.8, ease: "power4.inOut",
				scrollTrigger: {
					trigger: ".cam-view-3", start: "top center", end: "top top", scrub: 1, immediateRender: false
					,pin: '.eco-text', pinSpacing: false
				}
			})
			.addLabel("Eco")

			// CUSTOMIZE SECTION
			.to(position, {
				x: -5.5, y: -0.5, z: 7.4,
				scrollTrigger: {
					trigger: ".cam-view-4", start: "top bottom", end: "top top", scrub: true, immediateRender: false,
				}, onUpdate
			})
			.to(target, {
				x: -0.18, y: -0.02, z: 0.14,
				scrollTrigger: { trigger: ".cam-view-4", start: "top bottom", end: "top top", scrub: true, immediateRender: false }, onUpdate
			})
			.to(clock.rotation, {
				x: 0, y: 0, z: 0,
				scrollTrigger: { trigger: ".cam-view-4", start: "top bottom", end: "top top", scrub: true, immediateRender: false }
			})
			.fromTo('.customize--content', { opacity: 0 }, {
				opacity: 1, duration: 0.5, ease: "power4.out",
				scrollTrigger: {
					trigger: ".cam-view-4", start: "top center", end: "top top", scrub: 1, immediateRender: false,
				}
			})
			.addLabel("Customize")

			//GALLERY SECTION
			.to(clock.rotation, {
				x: 0, y: Math.PI, z: 0,
				scrollTrigger: { trigger: "#photos", start: "top bottom", end: "top top", scrub: true, immediateRender: false }, onUpdate
			})
			.fromTo('.photos-content h2', { opacity: 0}, { opacity: 1, ease: "power1.inOut", duration: 0.8,
				scrollTrigger: {
					trigger: ".photos-content h2", start: "top bottom", end: 'top top', scrub: 1, immediateRender: false
				}
			})
			.fromTo('.photos-content .photo-1', { y: '200px'}, { y: '0', ease: "power1.inOut", duration: 0.8,
				scrollTrigger: {
					trigger: ".photos-content .photo-1", start: "top bottom", end: 'top top', scrub: 1, immediateRender: false
				}
			})
			.fromTo('.photos-content .photo-2', { y: '200px'}, { y: '-100px', ease: "power1.inOut", duration: 0.4,
				scrollTrigger: {
					trigger: ".photos-content .photo-2", start: "top bottom", end: 'top top', scrub: 1, immediateRender: false
				}
			})
			.fromTo('.photos-content .photo-3', { y: '200px'}, { y: '-100px', ease: "power1.inOut", duration: 0.6,
				scrollTrigger: {
					trigger: ".photos-content .photo-3", start: "top bottom", end: 'top top', scrub: 1, immediateRender: false
				}
			})
			.fromTo('.photos-content .photo-4', { y: '200px'}, { y: '-100px', ease: "power1.inOut", duration: 0.8,
				scrollTrigger: {
					trigger: ".photos-content .photo-3", start: "bottom bottom", end: 'top top', scrub: 1, immediateRender: false
				}
			})

	}

	let needsUpdate = true;
	function onUpdate() {
		needsUpdate = true;
		// dof.enabled = true;
		viewer.renderer.resetShadows()

	}

	viewer.addEventListener('preFrame', () => {
		if (needsUpdate) {
			camera.positionUpdated(false)
			camera.targetUpdated(true)
			// viewer.setDirty()
			needsUpdate = false;
		}

		const time = new Date();
		let secondHandRotation = (time.getSeconds() + time.getMilliseconds()/1000) * (Math.PI * 2) / 60 ;
		let minuteHandRotation = time.getMinutes() * (Math.PI * 2) / 60 + secondHandRotation / 60;
		let hourHandRotation = time.getHours() * (2 * Math.PI) / 12 + minuteHandRotation / 12;
		if(Math.abs(Math.PI*3 - secondHandRotation - secondHand.rotation.y) > 0.001){
			secondHand.rotation.y = Math.PI*3 - secondHandRotation;
			minuteHand.rotation.y = Math.PI*3 - minuteHandRotation;
			hourHand.rotation.y = Math.PI*3 - hourHandRotation;
			viewer.renderer.resetShadows();
			viewer.setDirty();
		}
	})

	// KNOW MORE EVENT
	document.querySelector('.btn-white')?.addEventListener('click', () => {
		const element = document.querySelector('.cam-view-2')
		window.scrollTo({ top: element?.getBoundingClientRect().top, left: 0, behavior: 'smooth' })
	})

	// SCROLL TO TOP
	document.querySelectorAll('.backTop')?.forEach(item => {
		item.addEventListener('click', () => {
			window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
		})
	})

	// CUSTOMIZE EVENT
	buttonCustomize.addEventListener('click', () => {
		customizeContent.style.display = "none"
		exploreView.style.pointerEvents = "none"
		canvasView.style.pointerEvents = "all"
		// canvasContainer.style.zIndex = "1"
		document.body.style.overflowY = "hidden"
		document.body.style.cursor = "grab"
		configAnimation()
	})

	function configAnimation() {
		const tlExplore = gsap.timeline()

		tlExplore.to(position, {x: 5,  z: 8, duration: 1.5, onUpdate })
			.to('#photos', { opacity: 0, yPercent: 120, duration: 1.5, ease: "power4.out" }, '-=1.5')
			.to('.eco--container', { opacity: 0, yPercent: -120, duration: 1.5, ease: "power4.out", onComplete: onCompleteExplore }, '-=1.5')
	}

	function onCompleteExplore() {
		exitContainer.style.display = "flex"
		exitContainer.style.opacity = "1"

		if (camera.controls){
			camera.controls.enabled = true
			// camera.controls.autoRotate = true
			camera.controls.minDistance = 5
            camera.controls.maxDistance = 10
		}
	}

	document.querySelector('.button--exit')?.addEventListener('click', () => {
        exploreView.style.pointerEvents = "all"
        canvasView.style.pointerEvents = "none"
        document.body.style.overflowY = "auto"
        exitContainer.style.display = "none"
        document.body.style.cursor = "auto"
		customizeContent.style.display = "flex"
        exitConfigAnimation()
    })

    // EXIT EVENT
    function exitConfigAnimation(){

        if(camera.controls){
            camera.controls.enabled = false
            camera.controls.minDistance = 0
            camera.controls.maxDistance = 40
        }

        // if (document.querySelector('.footer--menu li.active')){
        //     document.querySelector('.footer--menu li.active')?.classList.remove('active')
        // }

        const tlExit = gsap.timeline()

        tlExit.to(position,{x: -5.5, y: -0.5, z: 7.4, duration: 1.2, ease: "power4.out", onUpdate})
		.to('#photos', { opacity: 1,yPercent: 0, duration: 1.2, ease: "power4.out" })
		.to('.eco--container', { opacity: 1, yPercent: 0, duration: 1.2, ease: "power4.out" }, '-=1.2')


    }

	// STRAP COLORS EVENT
	document.querySelector('.strap--colors > .button--colors.white')?.addEventListener('click', () => {
        changeStrapColor(new Color(0xd2d2d2).convertSRGBToLinear(), 0.7)
	})
	document.querySelector('.strap--colors > .button--colors.black')?.addEventListener('click', () => {
        changeStrapColor(new Color(0x101010).convertSRGBToLinear(), 0.34)

	})
	document.querySelector('.strap--colors > .button--colors.white2')?.addEventListener('click', () => {
        changeStrapColor(new Color(0xd2d2d2).convertSRGBToLinear(), 0.25)
	})
	document.querySelector('.strap--colors > .button--colors.black2')?.addEventListener('click', () => {
        changeStrapColor(new Color(0x101010).convertSRGBToLinear(), 0.7)

	})
	document.querySelector('.strap--colors > .button--colors.blue')?.addEventListener('click', () => {
        changeStrapColor(new Color(0x6487c6).convertSRGBToLinear(), 0.7)

	})
	document.querySelector('.strap--colors > .button--colors.green')?.addEventListener('click', () => {
        changeStrapColor(new Color(0x87A37D).convertSRGBToLinear(), 0.7)

	})
	document.querySelector('.strap--colors > .button--colors.red')?.addEventListener('click', () => {
        changeStrapColor(new Color(0xE26A5B).convertSRGBToLinear(), 0.7)

	})
	document.querySelector('.strap--colors > .button--colors.yellow')?.addEventListener('click', () => {
        changeStrapColor(new Color(0xE2BF41).convertSRGBToLinear(), 0.6)

	})

	// FACE COLORS EVENT
	document.querySelector('.face--colors > .button--colors.white')?.addEventListener('click', () => {
        changeFaceColor(new Color(0xf8f8f9).convertSRGBToLinear().convertSRGBToLinear(), 0.7)
	})
	document.querySelector('.face--colors > .button--colors.white2')?.addEventListener('click', () => {
        changeFaceColor(new Color(0xd2d2d2).convertSRGBToLinear().convertSRGBToLinear(), 0.4)
	})
	document.querySelector('.face--colors > .button--colors.black')?.addEventListener('click', () => {
        changeFaceColor(new Color(0x181818).convertSRGBToLinear().convertSRGBToLinear(), 0.3)
	})
	document.querySelector('.face--colors > .button--colors.blue')?.addEventListener('click', () => {
        changeFaceColor(new Color(0x1c76a5).convertSRGBToLinear(), 0.3)
	})
	document.querySelector('.face--colors > .button--colors.red2')?.addEventListener('click', () => {
        changeFaceColor(new Color(0xEDBF8A).convertSRGBToLinear(), 0.6)
	})

	// CHANGE STRAP COLOR
	function changeStrapColor(_colorToBeChanged: Color, _roughness: number){
		strapMaterial.color = _colorToBeChanged
		strapMaterial.roughness = _roughness
		viewer.scene.setDirty()
	}

	// CHANGE FACE COLOR
	function changeFaceColor(_colorToBeChanged: Color, _roughness: number){
		caseMaterial.color = _colorToBeChanged
		scrubberMaterial.color = _colorToBeChanged
		scrubberMaterial.roughness = _roughness
		scrubberMaterialCenter.color = _colorToBeChanged
		scrubberMaterialCenter.roughness = _roughness
		caseMaterial.roughness = _roughness
		viewer.scene.setDirty()
	}
	
}

setupViewer()